
import { computed, defineComponent, onBeforeMount, ref } from 'vue';
import { ModalsContainer } from 'vue-final-modal';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

import isNil from 'lodash-es/isNil';

import MainTemplate from '@hems/component/src/templates/MainTemplate.vue';
import HealthCheckContainer from '@hems/container/src/template/HealthCheckContainer.vue';
import { useLanguage } from '@hems/util/src/composable/language';
import { TERMS_CATEGORY } from '@hems/util/src/constant/terms';

export default defineComponent({
  name: 'App',
  components: {
    MainTemplate,
    HealthCheckContainer,
    ModalsContainer,
  },
  setup() {
    const route = useRoute();
    const { locale: i18nLocale } = useI18n();
    const { languageCode } = useLanguage();

    const isLoad = ref(false);

    const isTermsPage = computed(
      () =>
        !isNil(route.name) &&
        (route.name === TERMS_CATEGORY.TERMS_OF_SERVICE || route.name === TERMS_CATEGORY.TERMS_OF_PRIVACY)
    );

    // 초기화
    i18nLocale.value = languageCode.value;

    onBeforeMount(async () => {
      if (!isTermsPage.value) {
        isLoad.value = true;
      }
    });

    return {
      languageCode,
      isTermsPage,
      isLoad,
    };
  },
});
